import type { Store } from '../../../store/list/types';

/**
 * Set recording as 'watched', which is reflected in the recordings list as a
 * grey recording.
 */
export const setRecordingAsWatched = (store: Store, recordingId: number): void => {
  const { recordings, setRecordings } = store.getState();

  const newRecordings = recordings.map((recording) => {
    if (!recording.watched && recordingId === recording.id) {
      return { ...recording, watched: true };
    }
    return recording;
  });

  setRecordings(newRecordings);
};
